export abstract class UIDProvider {
  abstract createUID(): string;
}
